import { z } from 'zod'

/**
 * Environment, validated at startup so a missing variable crashes at boot
 * rather than surfacing as a broken screen three routes in (§6.12).
 */
const Env = z.object({
  VITE_API_URL: z.string().min(1).default('/api'),
  VITE_USE_MOCKS: z
    .string()
    .optional()
    .transform((value) => value === 'true'),
  /**
   * The public origin, for absolute URLs in metadata.
   *
   * `window.location.origin` is right at runtime and WRONG at prerender time:
   * the snapshot is taken against a throwaway local server, so canonical,
   * `og:url` and every `hreflang` were being baked as `http://localhost:4178`
   * — correct-looking in `dist`, and nonsense in every share.
   *
   * Optional, because a normal dev run has no meaningful public origin and
   * falls back to the live one. The prerender step refuses to run without it.
   */
  VITE_SITE_URL: z.string().url().optional(),
  /**
   * The public website (coeurentete.ca), where the logo on the signed-out pages
   * leads — distinct from VITE_SITE_URL, which is this app's own origin.
   */
  VITE_WEBSITE_URL: z.string().url().default('https://www.coeurentete.ca'),
})

const parsed = Env.safeParse(import.meta.env)

if (!parsed.success) {
  throw new Error(
    `Invalid environment:\n${parsed.error.issues.map((i) => `  ${i.path.join('.')}: ${i.message}`).join('\n')}`,
  )
}

export const env = parsed.data
